import React from 'react'

import clsx from 'clsx'

import Accordion from 'components/Accordion'
import Avatars from 'components/Avatars'
import Grid from 'components/Grid'
import Icon from 'components/Icon'
import Link from 'components/Link'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'
import detachTask from 'helpers/detachTask'
import { thousandSeparator } from 'helpers/formatters'
import useViewport from 'hooks/useViewport'

import classes from './Snippets.module.scss'

/** @type {import("./types").default} */
const Snippets = ({ listing, isFirstCard }) => {
  const { sendEvent, addEvent } = useEventContext()
  const { is } = useViewport()
  const isMobile = is('xs')

  const {
    feature: { snippets },
    num_reviews,
    pros,
    cons,
  } = listing

  const title = `Pros and Cons based on ${thousandSeparator(num_reviews)} verified reviews`
  // eslint-disable-next-line no-unused-vars
  const avatars = snippets.map(snippet => snippet.avatar).sort((a, b) => (a === null ? -1 : 1))
  const accordionOnExpandClick = (_, { isExpanded }) => {
    detachTask(sendEvent, {
      engagementDestination: (isExpanded ? 'open' : 'close') + '_pros-cons-accordion',
      engagementDetails: isExpanded
        ? 'text-link_see-individual-user-reviews'
        : 'text-link_hide-individual-user-reviews',
      name: 'engagement_product_click',
      engagementComponent: 'best-product_card-item_pros-cons-accordeon',
    })
  }

  if (!pros.length && !cons.length) return null

  return (
    <Accordion
      defaultExpanded={!!isFirstCard}
      onExpandClick={accordionOnExpandClick}
      summary={
        <div className={classes.accordionSummary}>
          <Typography variant="heading-xs" component="span">
            {title}
          </Typography>
          {!isMobile && <Avatars imagesUrl={avatars} className={classes.avatars} imageSize={24} />}
        </div>
      }
      detailsClassname={classes.accordionDetails}
      details={
        <Grid container className={classes.details}>
          <Grid item xs={12} sm={6} className={classes.row}>
            {pros.length &&
              pros.map(pro => (
                <div className={classes.titleContainer} key={`pro-${pro}`}>
                  <Icon size={16} className={clsx(classes['iconPros'], classes.icon)} icon={'caret-circle-up'} />
                  <Typography variant="body-xs">{pro}</Typography>
                </div>
              ))}
          </Grid>
          <Grid item xs={12} sm={6} className={classes.row}>
            {cons.length &&
              cons.map(con => (
                <div className={classes.titleContainer} key={`con-${con}`}>
                  <Icon size={16} className={clsx(classes['iconCons'], classes.icon)} icon={'caret-circle-down'} />
                  <Typography variant="body-xs">{con}</Typography>
                </div>
              ))}
          </Grid>
          <Link
            className={classes.link}
            href={`${listing.cta_urls.detail}#pros-cons`}
            {...addEvent({
              engagementComponent: 'best-product_card-item',
              engagementDetails: 'text-link_see-pros-and-cons',
              engagementDestination: 'go-to_product-details_pros-and-cons',
              name: 'engagement_product_click',
            })}
          >
            See pros and cons details
          </Link>
        </Grid>
      }
    />
  )
}

export default Snippets
